import React from 'react';
import { Message } from '../App';
import { ChatInput } from './ChatInput';
import { PanelLeftIcon, ArrowLeftIcon, MicIcon } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { mockData } from '../utils/mockData';
import { Logo } from './common/Logo';
interface ChatSidebarProps {
  isCollapsed: boolean;
  onToggleCollapse: () => void;
  onSendMessage: (message: string) => void;
  isVoiceMode: boolean;
  onToggleVoiceMode: () => void;
}
export const ChatSidebar = ({
  isCollapsed,
  onToggleCollapse,
  onSendMessage,
  isVoiceMode,
  onToggleVoiceMode
}: ChatSidebarProps) => {
  const navigate = useNavigate();
  const {
    id
  } = useParams();
  const chatMessages = id ? mockData.transcriptChats[id as keyof typeof mockData.transcriptChats] || [] : [];
  return <aside className={`bg-[#1f1f1f] flex flex-col border-r border-[#444444] transition-all duration-300 ${isCollapsed ? 'w-[60px]' : 'w-[300px]'}`} data-id="element-71">
      <div className="h-12 px-2 border-b border-[#444444] flex items-center gap-2" data-id="element-72">
        <button onClick={onToggleCollapse} className="p-2 hover:bg-[#2a2a2a] rounded-lg transition-colors" title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'} data-id="element-73">
          <PanelLeftIcon size={20} className={`text-[#888888] transition-transform duration-300 ${isCollapsed ? 'rotate-180' : ''}`} data-id="element-74" />
        </button>
        {!isCollapsed && <>
            <div className="flex-grow flex items-center gap-2" data-id="element-75">
            </div>
            <button onClick={() => navigate('/')} className="p-2 hover:bg-[#2a2a2a] rounded-lg transition-colors text-[#888888]" title="Back to chat" data-id="element-76">
              <ArrowLeftIcon size={20} data-id="element-77" />
            </button>
          </>}
      </div>
      <div className="flex-grow overflow-y-auto p-4" data-id="element-78">
        {!isCollapsed && <div className="space-y-4" data-id="element-79">
            {chatMessages.map(message => <div key={message.id} className={`flex gap-4 ${message.role === 'user' ? 'flex-row-reverse' : ''}`} data-id="element-80">
                <div className={`w-8 h-8 ${message.role === 'user' ? 'rounded-full bg-[#4a90e2]' : ''} flex items-center justify-center text-white font-bold flex-shrink-0`} data-id="element-81">
                  {message.role === 'user' ? 'U' : <Logo size={28} data-id="element-82" />}
                </div>
                <div className={`flex-grow rounded-xl p-3 text-sm ${message.role === 'user' ? 'bg-[#1f1f1f] border border-[#383838]' : 'bg-[#2a2a2a]'}`} data-id="element-83">
                  {message.content}
                </div>
              </div>)}
          </div>}
      </div>
      {!isCollapsed && <div className="p-4 border-t border-[#444444]" data-id="element-84">
          <ChatInput onSendMessage={onSendMessage} data-id="element-85" />
        </div>}
    </aside>;
};